export var MEGA_MENU_GRAPHQL_OPERATION_NAME = "HeaderConfiguration";